import { render, staticRenderFns } from "./memberships.vue?vue&type=template&id=13df19af&"
import script from "./memberships.vue?vue&type=script&lang=ts&"
export * from "./memberships.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports